module.exports = __webpack_public_path__ + "img/1-game.f16ede64.jpg";